<template>
  <div class="navbar-fixed-content" style="padding-top: 70px">
    <my-account-header></my-account-header>
    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>

        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li class :class="[showByMy ? '' : 'active']">
                <a
                  class="a-tab"
                  data-status="2"
                  data-toggle="tab"
                  @click="showByMyJoin()"
                  >我参加的直播</a
                >
              </li>
              <li :class="[showByMy ? 'active' : '']">
                <a
                  class="a-tab"
                  data-status="1"
                  data-toggle="tab"
                  @click="showByMyLive()"
                  >我发起的直播</a
                >
              </li>
            </ul>
            <!-- <button
              id="createZB"
              style="float: right; margin-top: -45px; margin-right: 20px;"
              @click="myZbClick(-1)"
            >我要直播</button> -->
            <!-- <button
              id="createZB"
              style="float: right; margin-top: -45px; margin-right: 20px"
              @click="myExamClick()"
            >
              我要考试
            </button> -->
            <div class="tab-content">
              <!-- v-show="showByMy" -->
              <div
                :class="[showByMy ? 'tab-pane active' : 'tab-pane']"
                id="tab_2_1"
              >
                <div class="div-zb">
                  <div class="div-head">
                    <div class="div1">直播封面/主题/内容介绍</div>
                    <div class="div2">直播时长</div>
                    <div class="div3">直播规模</div>
                    <div class="div4">状态</div>
                    <div class="div5">审核意见</div>
                    <div class="div6">操作</div>
                  </div>
                  <div class="div-body">
                    <div class="div-item" v-for="(item, index) in myLiveLists">
                      <div class="time">{{ item.endTimeS }}</div>
                      <div class="content">
                        <div class="div1">
                          <img :src="item.logo" class="logo" />
                          <div class="img-right">
                            <h2 :title="item.title">{{ item.title }}</h2>
                            <span :title="item.content">{{
                              item.content
                            }}</span>
                          </div>
                        </div>
                        <div class="div2">{{ item.timeLong }}分钟</div>
                        <div class="div3">{{ item.scale }}人</div>
                        <div class="div4" v-if="item.auditStatus == -1">
                          未审核通过
                        </div>
                        <div class="div4" v-else-if="item.auditStatus == 0">
                          审核中
                        </div>
                        <div class="div4" v-else>审核通过</div>
                        <div class="div5">
                          <span class="notext" v-if="item.auditMind == null"
                            >——</span
                          >
                          <span class="notext" v-else>{{
                            item.auditMind
                          }}</span>
                        </div>
                        <div class="div6">
                          <a class="deleteIt" data-id="221">
                            <img src="/Images/new/icon-delete.png" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-12 loading-more"
                      v-if="
                        query_data[0].MaxResultCount * query_data[0].PageIndex <
                        query_data[0].totalCount
                      "
                      @click="loadMoreByMy()"
                    >
                      加载更多
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="[showByMy ? 'tab-pane' : 'tab-pane active']"
                id="tab_2_2"
              >
                <div class="div-zb">
                  <div
                    style="
                      line-height: 30px;
                      height: 30px;
                      color: #ee6767;
                      font-size: 13px;
                    "
                  >
                    学习时长=直播观看时长+回放时长（累计），45分钟学习时长等于1课时
                    <!-- ，总学习时长大于直播时长的85%则得到全部课时否则为0 -->
                  </div>
                  <div class="div-head">
                    <div class="div1">直播封面/主题/内容介绍</div>
                    <div class="div2">直播时长</div>
                    <div class="div3">直播规模</div>
                    <div class="div4">状态</div>
                    <div class="div7">学习总时长</div>
                    <div class="div7">课时</div>
                    <div class="div6">操作</div>
                  </div>

                  <div class="div-body">
                    <div
                      class="div-item live-item"
                      v-for="(item, index) in myJoinLiveLists"
                    >
                      <div class="time">{{ item.endTimeS }}</div>
                      <div class="content">
                        <div class="div1">
                          <img :src="item.logo" class="logo" />
                          <div class="img-right">
                            <h2 :title="item.title">{{ item.title }}</h2>
                            <span :title="item.content">{{
                              item.content
                            }}</span>
                          </div>
                        </div>
                        <div class="div2">{{ item.timeLong }}分钟</div>
                        <div class="div3">{{ item.scale }}人</div>
                        <div class="div4" v-if="item.state == 0">未开始</div>
                        <div class="div4" v-if="item.state == 1">进行中</div>
                        <div class="div4" v-if="item.state == 2">已经结束</div>
                        <div class="div7 live-time" style="width: 10%">
                          {{ myJoinLiveSumRecordTime[index] }}分钟
                        </div>
                        <div class="div7 back-time" style="width: 10%">
                          {{ item.hour }}课时
                        </div>
                        <!-- {{myJoinLiveSumRecordTime |trainingTimeFilter(myJoinLiveSumRecordTime[index],item)}} -->
                        <div class="div6" style="width: 12%">
                          <a
                            class
                            v-if="item.state == 2 && item.hasBackPlay == 0"
                            >--</a
                          >
                          <a
                            class="finished"
                            v-else-if="item.state == 2 && item.hasBackPlay == 1"
                            @click="playback(item)"
                          ></a>
                          <a
                            class="start"
                            v-else-if="item.state == 0"
                            @click="start(item)"
                          ></a>
                          <a
                            class="start"
                            v-else-if="item.state == 1 && item.hasBackPlay == 0"
                            @click="start(item)"
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-12 loading-more"
                      v-if="
                        query_data[1].MaxResultCount * query_data[1].PageIndex <
                        query_data[1].totalCount
                      "
                      @click="loadMoreByJoin()"
                    >
                      加载更多
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-dialog :visible.sync="showMyZb" width="60%" title="直播申请">
            <!-- <div class="modal-header" style="border-bottom:1px solid #ccc">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="myZbClick(0)"
                >
                  <span aria-hidden="true">X</span>
                </button>
            </div>-->
            <el-divider></el-divider>
            <div class="zb-modal-left">
              <span class="pspan">
                <label>直播主题</label>
                <input
                  type="text"
                  class="long"
                  id="title"
                  v-model="liveFormData.zbTitle"
                />
              </span>
              <span class="pspan">
                <label>时间设置</label>
                <!-- <el-date-picker
                  v-model="value1"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="margin-left:9px;border-color:#cecece;"
                  unlink-panels="true"
                ></el-date-picker> -->
                <el-date-picker
                  size="large"
                  v-model="liveFormData.zbStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  :clearable="false"
                ></el-date-picker>
                <span> 至 </span>
                <el-date-picker
                  size="large"
                  v-model="liveFormData.zbEndTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  :clearable="false"
                  style="width: 190px; left: 20px"
                ></el-date-picker>
              </span>
              <span class="pspan">
                <label>直播时长</label>
                <input
                  type="text"
                  class="short"
                  id="TimeLong"
                  v-model="liveFormData.zbTotalTime"
                />
                分钟
              </span>
              <span class="pspan">
                <label>内容介绍</label>
                <textarea
                  id="Content"
                  v-model="liveFormData.zbIntroduction"
                ></textarea>
              </span>
              <span class="pspan">
                <label>直播班级</label>
                <span class="long" id="classes">
                  <div v-for="item in mySelectClassArr">
                    <span class="classname1">
                      {{ item.name }}
                      <a @click="deleteMySelectClass(item)">×</a>
                    </span>
                  </div>
                </span>
                <a id="chooseclass" @click="showChosseClassClick(2)"
                  >选择班级</a
                >
              </span>
              <span class="pspan">
                <label>直播规模</label>
                <input
                  type="text"
                  class="short"
                  id="scale"
                  disabled="disabled"
                  v-model="liveFormData.zbTotalPeople"
                />
                人
              </span>
            </div>
            <div class="zb-modal-right" style="top: 80px">
              <button id="uploader-logo" style="height: 0">
                <div class="qq-uploader-selector qq-uploader" qq-drop-area-text>
                  <div
                    class="qq-upload-drop-area-selector qq-upload-drop-area"
                    qq-hide-dropzone
                    style="display: none"
                  ></div>
                  <div
                    class="qq-upload-button-selector qq-upload-button"
                    style="position: relative; overflow: hidden; direction: ltr"
                  >
                    <div>选择文件</div>
                    <input
                      title="file input"
                      type="file"
                      name="qqfile"
                      style="
                        position: absolute;
                        right: 0px;
                        top: 0px;
                        font-family: Arial;
                        font-size: 118px;
                        margin: 0px;
                        padding: 0px;
                        cursor: pointer;
                        opacity: 0;
                        height: 100%;
                      "
                    />
                  </div>

                  <span
                    class="
                      qq-drop-processing-selector qq-drop-processing qq-hide
                    "
                    style="display: none"
                  >
                    <span>Processing dropped files...</span>
                    <span
                      class="
                        qq-drop-processing-spinner-selector
                        qq-drop-processing-spinner
                      "
                    ></span>
                  </span>

                  <ul
                    class="qq-upload-list-selector qq-upload-list"
                    aria-live="polite"
                    aria-relevant="additions removals"
                    style="display: none"
                  ></ul>
                </div>
              </button>
              <div id="uploadImg">
                <img
                  :src="liveFormData.zbimg"
                  id="zbimg"
                  style="display: block"
                />
                <div class="pt">
                  <img src="/Images/new/add.jpg" style="width: 27px" />
                  <span>添加直播封面</span>
                </div>

                <span
                  style="
                    position: absolute;
                    left: 0;
                    text-align: center;
                    width: 100%;
                    bottom: -30px;
                  "
                  >上传文件小于500KB</span
                >
                <input
                  title="file input"
                  type="file"
                  name="qqfile"
                  style="
                    position: absolute;
                    left: 0px;
                    right: 0px;
                    top: 0px;
                    font-family: Arial;
                    font-size: 118px;
                    margin: 0px;
                    padding: 0px;
                    cursor: pointer;
                    opacity: 0;
                    height: 100%;
                  "
                  @change="changeZbImage($event)"
                />
              </div>
            </div>

            <div class="modal-footer">
              <button
                class="cancel-question"
                id="cancleZb"
                @click="myZbClick(0)"
              >
                取消
              </button>
              <button
                class="submit-question"
                id="submitZb"
                @click="myZbClick(1)"
              >
                提交
              </button>
            </div>
          </el-dialog>

          <div
            :class="[showChosseClass ? 'modal fade' : 'modal fade in']"
            id="zb-class-modal"
            tabindex="-1"
            role="dialog"
            :style="{ display: showChosseClass ? 'none' : 'block' }"
          >
            <div class="modal-dialog-zb-class" role="document">
              <div class="modal-content">
                <div class="modal-header" style="border-bottom: 1px solid #ccc">
                  <span class="title">选择班级</span>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="showChosseClassClick(0)"
                  >
                    <span aria-hidden="true">X</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="left">
                    <div
                      class="search"
                      style="float: none; width: 300px; margin: 5px 0"
                    >
                      <div class="h-search">
                        <input placeholder="输入要查找的内容" class="keyword" />
                        <img src="/Images/Home/top3.png" class="btn_search" />
                        <div></div>
                      </div>
                    </div>
                    <div class="class-pan">
                      <div
                        class="class-item"
                        v-for="(item, index) in myAllClassLists"
                      >
                        <img :src="item.logo" />
                        <span class="classname">{{ item.name }}</span>
                        <button
                          :class="[
                            mySelectClassArr.includes(item)
                              ? 'radio-btn selected'
                              : 'radio-btn',
                          ]"
                          @click="selectClassClick(item)"
                        ></button>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <!-- {{mySelecttClassArr.length}}{{myAllClassLists.length}} -->
                    <span>
                      已选
                      <span class="selectedClassNum">{{
                        mySelectClassArr != undefined &&
                        mySelectClassArr != null
                          ? mySelectClassArr.length
                          : "0"
                      }}</span
                      >/
                      <span class="totalClassNum">{{
                        myAllClassLists.length
                      }}</span>
                    </span>
                    <div class="selected-class">
                      <div class="class-item" v-for="item in mySelectClassArr">
                        <img :src="item.logo" />
                        <span class="classname">{{ item.name }}</span>
                        <button class="radio-btn {selected}"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    class="cancel-question"
                    id="cancleZbclass"
                    @click="showChosseClassClick(0)"
                  >
                    取消
                  </button>
                  <button
                    class="submit-question"
                    id="submitClass"
                    @click="showChosseClassClick(1)"
                  >
                    添加
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- 我要下载 -->
          <div class="modal fade" id="fabu-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-header" style="border-bottom: 1px solid #ccc">
                <span class="title">客户端安装提示</span>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="tishi_div">
                  检测到您电脑云端课程本地客户端未安装，请下载
                </div>
                <a href="/Images/bjyclient7.5.6.zip" class="down_client"
                  >下载云端课堂客户端</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { playBack } from "../common/common";
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";
import store from "@/store/store";
import axios from "axios";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: [
        {
          stopajax: !1,
          MaxResultCount: 5,
          PageIndex: 0,
          totalCount: 0,
          index: 0,
          SkipCount: 0,
        },
        {
          stopajax: !1,
          MaxResultCount: 5,
          PageIndex: 0,
          totalCount: 0,
          index: 0,
          SkipCount: 0,
        },
      ],
      liveFormData: {
        zbTitle: "",
        zbimg: "",
        zbStartTime: "",
        zbEndTime: "",
        zbCreateTime: "",
        zbTotalTime: "",
        zbIntroduction: "",
        zbTotalPeople: 0,
        AuditStatus: 0,
        AuditMind: "",
        ClassId: [],
        TeacherId: "",
        CreatorUserId: "",
      },
      imageFileData: {
        uuid: "",
        filename: "",
        filesize: "",
        file: "",
      },
      myLiveLists: [],
      myJoinLiveLists: [],
      myJoinLiveSumRecordTime: [],
      myAllClassLists: [],
      mySelectClassArr: [],
      showByMy: false,
      showMyZb: false,
      showChosseClass: true,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },

  mounted() {
    this.loadMoreByMy();
    this.loadMoreByJoin();
    this.loadMyAllClass();
  },
  methods: {
    loadMoreByMy: function () {
      // 获取全部
      comFun.getLiveListByMyInitiate(this.query_data[0]).then((res) => {
        this.myLiveLists = this.myLiveLists.concat(res.items);
        this.query_data[0].totalCount = res.totalCount;
        if (
          this.query_data[0].PageIndex * this.query_data[0].MaxResultCount <
          this.query_data[0].totalCount
        ) {
          this.query_data[0].PageIndex = this.query_data[0].PageIndex + 1;
        } else {
          this.query_data[0].stopajax = 1;
        }
      });
    },
    loadMoreByJoin: function () {
      // 获取全部
      comFun.getLiveListByMyJoin(this.query_data[1]).then((res) => {
        this.query_data[1].totalCount = res.totalCount;
        if (
          this.query_data[1].PageIndex * this.query_data[1].MaxResultCount <
          this.query_data[1].totalCount
        ) {
          this.query_data[1].PageIndex = this.query_data[1].PageIndex + 1;
        } else {
          this.query_data[1].stopajax = 1;
        }
         var _index = this.myJoinLiveLists.length;
        this.myJoinLiveLists = this.myJoinLiveLists.concat(res.items);
        this.getUserLiveSumRecords(res.items,_index);
       
      });
    },
    async getUserLiveSumRecords(myJoinLists,index ) {
      for (let i = 0; i < myJoinLists.length; i++) {
        var res = await comFun.getUserLiveSumRecord(
          myJoinLists[i].id,
          this.userInfo.id
        );
        if (res.success) {
          this.myJoinLiveSumRecordTime.push(res.result);
          this.trainingTime(
            res.result,
            index+i,
            myJoinLists[i]
          );
        }
      }
    },
    loadMyAllClass: function () {
      comFun.getMyAllClass().then((res) => {
        this.myAllClassLists = res.result;
      });
    },

    showByMyLive: function () {
      this.showByMy = true;
    },
    showByMyJoin: function () {
      this.showByMy = false;
    },
    myExamClick() {
      var data = [
        { id: 3147, url: "https://ks.wjx.top/vj/Yo1F3wV.aspx" },
        { id: 3150, url: "https://ks.wjx.top/vj/wFcEkQp.aspx" },
        { id: 3149, url: "https://ks.wjx.top/vj/eDjYyQo.aspx" },
        { id: 3148, url: "https://ks.wjx.top/vj/eTyQoLL.aspx" },
      ];

      this.myAllClassLists.forEach((item) => {
        var res = data.find((x) => x.id == item.classId);
        if (res != undefined) {
          window.open(res.url, "_blank");
          return;
        }
      });
    },
    start(item) {
      comFun.start(item);
    },
    playback(item) {
      comFun.playback(item);
    },
    deleteLive(item, index) {
      comFun.getMoveLive(item).then((res) => {
        if (res.success == true) {
          this.myLiveLists.splice(index, 1);
          var msg = {
            type: "success",
            text: "删除成功！",
          };
          this.$store.dispatch("setMsg", msg);
        }
      });
    },

    myZbClick(t) {
      if (t == -1) {
        this.showMyZb = !this.showMyZb;
      } else if (t == 1) {
        var text = "";
        if (!this.liveFormData.zbTitle) {
          text = "直播主题不能为空";
        } else if (!this.liveFormData.zbStartTime) {
          text = "直播开始时间不能为空";
        } else if (!this.liveFormData.zbEndTime) {
          text = "直播结束时间不能为空";
        } else if (!this.liveFormData.zbIntroduction) {
          text = "直播介绍不能为空";
        } else if (!this.liveFormData.zbimg) {
          text = "直播图片不能为空";
        } else if (
          this.mySelectClassArr == undefined ||
          this.mySelectClassArr.length <= 0
        ) {
          text = "直播班级不能为空";
        }
        if (text) {
          this.loadMessageShow(text);
          text = "";
          return;
        }
        var str = "";
        this.mySelectClassArr.forEach(function (e) {
          str += e.classId + ",";
        });
        str = str.substring(0, str.length - 1);
        this.liveFormData.ClassId = str.split(",");

        var datejson = new Date().toJSON();
        var date = new Date(+new Date(datejson) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
        this.liveFormData.zbCreateTime = date;
        //tijiao
        this.liveFormData.AuditStatus = 0;

        this.liveFormData.TeacherId = this.userInfo.id;
        this.liveFormData.CreatorUserId = this.userInfo.id;
        comFun.createMyZb(this.liveFormData).then((res) => {
          if (res) {
            var msg = {
              type: "success",
              text: "直播申请添加成功",
            };
            this.$store.dispatch("setMsg", msg);
            this.loadMoreByMy();
          }
        });
        this.showMyZb = !this.showMyZb;
      } else if (t == 0) {
        this.showMyZb = !this.showMyZb;
      }
    },
    showChosseClassClick(t) {
      this.showChosseClass = !this.showChosseClass;
      if (t == 1) {
        //tianjiabanji
      } else if (t == 2) {
      }
    },
    changeZbImage: function (e) {
      var file = e.target.files[0];

      var that = this;
      let fd = new FormData();
      fd.append("qqfile", file);
      comFun.uploadImageFile(fd).then((res) => {
        if (res.success == true) {
          that.liveFormData.zbimg = res.result.fileUrl;
        }
      });
    },
    selectClassClick: function (t) {
      if (this.mySelectClassArr.indexOf(t) === -1) {
        this.mySelectClassArr.push(t);
        this.liveFormData.zbTotalPeople += t.realScale;
      } else {
        this.mySelectClassArr = this.mySelectClassArr.filter(function (ele) {
          return ele != t;
        });
        this.liveFormData.zbTotalPeople -= t.realScale;
      }
    },
    deleteMySelectClass(t) {
      this.mySelectClassArr = this.mySelectClassArr.filter(function (ele) {
        return ele != t;
      });
      this.liveFormData.zbTotalPeople -= t.realScale;
    },
    loadMessageShow(text) {
      var msg = {
        type: "error",
        text: text,
      };
      this.$store.dispatch("setMsg", msg);
    },
    trainingTime(data, index, item) {
      if (item.classId == "3087") {
        var a = (parseFloat(data) / item.timeLong).toFixed(2); //学习占比
        var b = 0; //学时
        var c = "";
        var d = 0.85; //达标
        //if (item.id == 208 || item.id == 209) {
        //    d = 0.66;
        //}
        if (a >= d) {
          b = (item.timeLong / 45).toFixed(0);
        }
        if (item.id == 193) {
          if (a >= d) {
            b = 4;
          }
        }
        if (item.id == 224) {
          if (a >= d) {
            b = 4;
          }
        }
        if (item.id == 223) {
          if (data >= 20) {
            b = 4;
          }
        }
        if (item.id == 193) {
          b = Math.round(parseFloat(data) / 0.85 / 45);
          if (b > 4) {
            b = 4;
          }
          if (b == 4) {
            c = "/ 已达标 ";
          }
        }
        if (b > 0 && item.id != 193) {
          c = "/ 已达标 ";
        }
        // $(".live-item-" + item.id + " .back-time").html(b + "课时" + c);
        this.myJoinLiveLists[index].hour = b;
      } else {
        var rate = 45;
        var _classids = item.classId.split(",");
        if (_classids.length > 0) {
          comFun.getMyClassNumber(_classids[0]).then((res) => {
            if (res.success) {
              if (res.result.success == "true") {
                rate = res.result.rate;
              }
            }
            this.myJoinLiveLists[index].hour = ((data > item.timeLong ? item.timeLong : data) / rate).toFixed(1);
            this.$set(this.myJoinLiveLists, index, this.myJoinLiveLists[index]);
          });
        }

        this.myJoinLiveLists[index].hour = ((data > item.timeLong ? item.timeLong : data) / rate).toFixed(1);
      }
    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog__body {
  padding: 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-input--prefix .el-input__inner {
  padding-left: 20px;
}
.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  line-height: 40px;
  margin-left: 6px;
}
.el-input--suffix .el-input__inner {
  padding-right: 10px;
}
.el-divider--horizontal {
  margin: 8px 0;
  /* background: 0 0; */
  border-top: 1px #e8eaec;
}
</style>